import { OrganizationKeyName } from "../../../model/Organization";

export const GET_ORDER = "SHOP:GET_ORDER";

export const getOrderAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_ORDER as typeof GET_ORDER,
  organization,
  id,
});

export type GetOrderAction = ReturnType<typeof getOrderAction>;
